export const API_GET_WIDGET = (widgetId, offset, sort, query) => `/widgets/api/${widgetId}?offset=${offset}${sort ? `&${sort}` : ''}${query ? `&${query}` : ''}`;
export default API_GET_WIDGET;
